import { createRestClient } from 'providers/tanstack-query-rest/client'

import type { AxiosInstance } from 'axios'

export const client: AxiosInstance = createRestClient({
  baseURL: import.meta.env.VITE_YIELDBIRD_WRAPPER_AGENT_API,
  headers: {
    'x-api-key': import.meta.env.VITE_YIELDBIRD_WRAPPER_AGENT_API_KEY,
  },
})
